module.exports = __webpack_public_path__ + "a3562c1e049626ed36cf7dd196eafdbc.jpg";